<template>
  <div class="target-class">
    <div v-if="buttonConfig.length>0" style="padding: 16px 20px;">
      <div>
        <div v-if="approver == false" style="display: flex;justify-content: space-between;">
          <div v-for="item in buttonConfig" :key="item.key">
            <div style="font-size: 13px;text-align: center">
              <div v-if="item.key == 'agree'">
                <el-popover placement="top" width="360" trigger="click">
                  <agree-drawer @close="close" @success="handleSuccess" :processInfo="processInfo" />
                  <template #reference>
                    <el-image  :src="require('/src/assets/image/agree.png')" class="image-style"/>
                    <div style="color: #6ac33e">{{ item.text }}</div>
                  </template>
                </el-popover>
              </div>

              <div v-if="item.text == '驳回'">
                <el-popover placement="top" width="360" trigger="click">
                  <refuse-drawer @close="close" @success="handleSuccess" :processInfo="processInfo" />
                  <template #reference>
                    <el-image :src="require('/src/assets/image/refuse-tool.png')" class="image-style"/>
                    <div style="color: #F56C6C">{{ item.text }}</div>
                  </template>
                </el-popover>
              </div>

              <div v-if="item.text == '评论'">
                <el-popover placement="top" width="360" trigger="click">
                  <comment-drawer @close="close" :processInfo="processInfo" />
                  <template #reference>
                    <el-image :src="require('/src/assets/image/comments.png')" class="image-style"/>
                    <div style="color: #606266">{{ item.text }}</div>
                  </template>
                </el-popover>
              </div>

              <div v-if="item.text == '撤销'">
                <el-popover placement="top" width="360" trigger="click">
                  <revoke-drawer @success="handleSuccess" :processInfo="processInfo" />
                  <template #reference>
                    <el-image @close="close" :src="require('/src/assets/image/revoke.png')" class="image-style"/>
                    <div style="color: #606266">{{ item.text }}</div>
                  </template>
                </el-popover>
              </div>
<!--              <div v-if="item.text == '退回'">-->
<!--                <el-image :src="require('/src/assets/image/rollback-tool.png')" class="image-style"/>-->
<!--                <div style="color: #facc15">{{ item.text }}</div>-->
<!--              </div>-->
<!--              <div v-if="item.text == '转办'">-->
<!--                <el-image  :src="require('/src/assets/image/assignee.png')" class="image-style"/>-->
<!--                <div style="color: #606266">{{ item.text }}</div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 评论 -->

    <!-- 委派 -->
    <delegate-modal @cancel="approver = false" :visible.sync="modalConfig.delegateVisible" :processInfo="processInfo" />
    <!-- 委派人完成 -->
<!--    <resolve-modal :visible.sync="modalConfig.resolveVisible" :processInfo="processInfo" />-->

    <!-- 转办 -->
    <assignee-drawer @cancel="approver = false" :visible.sync="modalConfig.assigneeVisible" :processInfo="processInfo" />
    <!-- 退回 -->
    <rollback-drawer @cancel="approver = false" :visible.sync="modalConfig.rollbackVisible" :processInfo="processInfo" />
    <!-- 加签 -->
    <add-multi-modal @cancel="approver = false" :visible.sync="modalConfig.addMultiVisible" :processInfo="processInfo" />
    <!-- 查到签上的人 -->
    <query-multi-user-modal @cancel="approver = false" :visible.sync="modalConfig.queryMultiUserVisible" :processInfo="processInfo" />
    <!-- 撤销 -->

    <!-- 减签 -->
    <delete-multi-modal @cancel="approver = false" :visible.sync="modalConfig.deleteMultiVisible" :processInfo="processInfo" />
  </div>
</template>

<script>
import AgreeDrawer from './AgreeDrawer';
import CommentDrawer from './CommentDrawer';
import DelegateModal from './DelegateModal';
import AssigneeDrawer from './AssigneeDrawer';
import RevokeDrawer from './RevokeDrawer';
import RefuseDrawer from './RefuseDrawer';
import RollbackDrawer from './RollbackDrawer';
import AddMultiModal from './AddMultiModal';
import QueryMultiUserModal from './QueryMultiUserModal';
import DeleteMultiModal from './DeleteMultiModal';

// 待我处理
// [同意]agree
// [委派]delegate
// [委派人完成]resolve
// [拒绝]refuse
// [转办]assignee
// [退回]rollback
// [加签]addMulti
// [减签]deleteMulti
// [评论]comments
// [查到签上的人]queryMultiUsersInfo
// const TODO_TASK_KEYS = ['agree', 'delegate', 'resolve', 'refuse', 'assignee', 'rollback', 'addMulti', 'deleteMulti', 'comments', 'queryMultiUsersInfo'];



const TODO_TASK_KEYS = ['agree', 'refuse', 'comments','assignee' , 'rollback', ];
// 我发起的
// [撤销] [评论]
const APPLY_TASK_KEYS = ['revoke', 'comments']

// 关于我的
// [撤销] [评论]
const DONE_TASK_KEYS = ['comments'];

// 根据类型 映射对应关系
const BUTTON_KEYS_MAP = {
  todoTask: TODO_TASK_KEYS,
  applyTask: APPLY_TASK_KEYS,
  doneTask: DONE_TASK_KEYS,
};

// 对应按钮映射关系
const OPERATION_BUTTON_MAP = {
  agree: "同意",
  delegate: "委派",
  // resolve: "委派人完成",
  refuse: "驳回",
  revoke: "撤销",
  comments: "评论",
  assignee: "转办",
  rollback: "退回",
  addMulti: "加签",
  queryMultiUsersInfo: "查到签上的人",
  deleteMulti: "减签",

}

export default {
  props: ["processInfo", "type"],
  components: {
    CommentDrawer,
    DelegateModal,
    AssigneeDrawer,
    RevokeDrawer,
    RefuseDrawer,
    RollbackDrawer,
    AddMultiModal,
    QueryMultiUserModal,
    DeleteMultiModal,
    AgreeDrawer
  },
  name: "ProcessForm",
  data() {
    return {
      approver:false,
      visible:false,
      modalConfig: {
        agreeVisible: false,
        commentVisible: false,
        delegateVisible: false,
        assigneeVisible: false,
        // resolveVisible: false,
        refuseVisible: false,
        rollbackVisible: false,
        addMultiVisible: false,
        queryMultiUserVisible: false,
        revokeVisible: false,
        deleteMultiVisible: false
      },
      state:null,
      fromData: {
        comments: "同意",
        processInstanceId: "",
        taskId: "",
      },
      select: [],
    };
  },
  computed: {
    // 当前节点类型：TASK=办理节点，APPROVAL=审批节点
    currentNodeType() {
      return this.processInfo?.currentNode?.type || "";
    },
    isTaskNode() {
      return this.currentNodeType === "TASK";
    },
    buttonConfig() {
      return Object.keys(OPERATION_BUTTON_MAP).filter(key => BUTTON_KEYS_MAP[this.state!=1? 'doneTask':this.type].includes(key)).map(key => {
        return {
          // 办理节点(TASK)的 agree 按钮显示"办理"，审批节点(APPROVAL)保持"同意"
          text: key === 'agree' && this.isTaskNode ? '办理' : OPERATION_BUTTON_MAP[key],
          key
        }
      })
    }
  },
  methods: {
    close(){
      const targetElement = document.querySelector('.target-class')
      // 触发点击事件
      targetElement.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    },
    // 同意/驳回/撤销 成功后的统一处理：延迟 1 秒返回上一页（列表页）
    handleSuccess(){
      setTimeout(() => {
        if (window.history.length > 1) {
          this.$router.back();
        } else {
          // 详情页是直接打开的（无历史记录）时兜底回「待我处理」
          this.$router.replace("/oa/form/todo");
        }
      }, 800);
    }
  },
};
</script>

<style scoped>
.image-style{
  width: 30px;height: 30px
}
</style>